import { Component, OnInit } from '@angular/core';
import { PackageModel } from 'src/app/model/stripe-models/product/package-model';
import { UserLocalSelectionService } from 'src/app/services/dataServices/user-local-selection-service/user-local-selection.service';
import { StripeService } from 'src/app/services/stripe-service/stripe.service';
import { UserService } from 'src/app/services/user-service/userservice';
import { DialogService } from 'src/app/services/dialog-service/dialog-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DialogErrorComponent } from 'src/app/components/dialog-windows/dialog-error/dialog-error.component';
import { OrganisationService } from 'src/app/services/dataServices/organisation-service/organisationservice';

@Component({
    selector: 'app-abo-payment',
    templateUrl: './abo-payment.component.html',
    styleUrls: ['./abo-payment.component.scss'],
    standalone: false
})
export class AboPaymentComponent implements OnInit {

  package: PackageModel;
  organisationId: number;
  message = "Beim Zahlvorgang ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.";

  constructor(private route: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private dialogService: DialogService,
    private userService: UserService, private localSelectionService: UserLocalSelectionService,
    private stripeService: StripeService,
    public organisationService: OrganisationService) {
    if (!this.userService.currentMemberships.find(
      (orga) =>
        orga.organisationId === this.organisationService.activeItem.organisationId
    )) {
      this.router.navigateByUrl('/marktplatz');
    }
  }

  ngOnInit(): void {
    this.organisationId = this.organisationService.activeItem.organisationId;
    this.route.queryParamMap.subscribe(params => {
      const paymentStatus = params.get('payment');
      if (paymentStatus === 'failed') {
        this.openPaymentFailedDialog();
      }
    });
    const selectedPackage = this.localSelectionService.getSelection('selectedPackage-register');
    if (selectedPackage && typeof selectedPackage === "object") {
      this.package = selectedPackage;
    } else {
      // redirecte to tarif page?
    }
  }


  payPackage(): void {
    const successUrl = 'http://localhost:4200/organisations/' + this.organisationId + '/aboPayment/confirmation';
    const cancelUrl = 'http://localhost:4200/'

    const paymentData = {
      successUrl,
      cancelUrl,
      quantity: 1,
      priceId: this.package.priceId.id,
      orgId: this.organisationId,
    };

    this.stripeService.addAndPay(paymentData).toPromise()
      .then(response => {
        if (response?.id) {
          window.location.href = response.id;
        } else {
          console.error('Ungültige Antwort von Stripe:', response);
        }
      })
      .catch(error => {
        console.error('Fehler beim Starten des Stripe-Checkouts:', error);
      });
  }

  openPaymentFailedDialog(): void {
    const dialogRef = this.dialogService.openErrorDialog(this.message, 'Abbrechen', 'Erneut versuchen');

    dialogRef.subscribe(result => {
      if (result === 'Abbrechen') {
        this.router.navigate(['/']);
      } else {
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: {},
          replaceUrl: true
        });
      }
    });
  }

}
